const SHOPPING_CART_ID = 'BAGGAGE';
const getProductName = ({idPassenger, idRow}) => `${SHOPPING_CART_ID}_${idPassenger}_${idRow}`;

const processIds = ([id] = []) => ({
    ...(id && {id}),
});

const decorate = (data = {}) => {
    const {quantity = 0, selection = {}} = data;

    return {
        ...data,
        id: getProductName(data),
        name: getProductName(data),
        quantity,
        selection,
    };
};

module.exports = {
    decorate,
    processIds,
    getProductName,
};
